export const featuredPlants = [
  {
    id: 1,
    name: "Snake Plant (Sansevieria)",
    description: "Thrives in low light. Excellent air purifier. Minimal water needs.",
    image: "https://images.stockcake.com/public/1/3/7/137120e9-27ea-460b-a3e1-d546ab399ed7_large/potted-snake-plant-stockcake.jpg",
    care: {
      light: "Low to bright indirect",
      water: "Every 2-3 weeks",
      humidity: "Low",
      temperature: "65-75°F"
    }
  },
  {
    id: 2,
    name: "ZZ Plant (Zamioculcas zamiifolia)",
    description: "Nearly indestructible. Perfect for beginners. Glossy, dark green leaves.",
    image: "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTPa3fqoO0W8Ux3sncYkTeiu1BQ5W_9xoDIVV3NepyIhsSNJ-OjzFCnl8cA0OhjnHazVkiXx5UJFw6GBA-3ayAD2gcRPucFQaoQnXPIj-sO",
    care: {
      light: "Low to bright indirect",
      water: "Every 2-4 weeks",
      humidity: "Low to medium",
      temperature: "65-75°F"
    }
  },
  {
    id: 3,
    name: "Peace Lily (Spathiphyllum)",
    description: "Beautiful white blooms. Tells you when it needs water. Great air purifier.",
    image: "https://images.stockcake.com/public/f/2/7/f2732030-7cd6-4899-8ef4-73140a4c43db_large/golden-spadix-detail-stockcake.jpg",
    care: {
      light: "Medium to bright indirect",
      water: "Weekly",
      humidity: "Medium to high",
      temperature: "68-85°F"
    }
  },
  {
    id: 4,
    name: "Spider Plant (Chlorophytum comosum)",
    description: "Easy to propagate. Produces baby plants. Great for hanging baskets.",
    image: "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcQT0Or1TZyi1tmBnEhPRPqUZi_E6aXoOq7A7t7_KmyBEAA8cPGLspc-h2BS5MWeyTyf13CvC4IPWgY5wjx2ZpU-paAhN5kJG1O14u3CrSX5",
    care: {
      light: "Bright indirect",
      water: "Weekly",
      humidity: "Medium",
      temperature: "65-75°F"
    }
  },
  {
    id: 5,
    name: "Aloe Vera",
    description: "Medicinal properties. Drought tolerant. Perfect for sunny spots.",
    image: "https://images.stockcake.com/public/9/b/3/9b325fd1-36f0-405c-a19d-4069c9af1efc_large/aloe-in-kitchen-stockcake.jpg",
    care: {
      light: "Bright direct",
      water: "Every 2-3 weeks",
      humidity: "Low",
      temperature: "60-75°F"
    }
  },
  {
    id: 6,
    name: "Lavender",
    description: "Aromatic herb. Calming properties. Beautiful purple flowers.",
    image: "https://images.stockcake.com/public/e/6/5/e652d89c-44e3-4209-95ac-5cd487b67014_large/dewy-pollinator-visit-stockcake.jpg",
    care: {
      light: "Bright direct",
      water: "Every 1-2 weeks",
      humidity: "Low",
      temperature: "60-70°F"
    }
  }
];

export const howToGuides = [
  {
    id: 1,
    title: "How to Repot Your Plant Without Stress",
    description: "Learn the gentle way to give your plants a new home without shocking their system.",
    icon: "🪴",
    steps: [
      "Choose the right time (spring/early summer)",
      "Select a pot 1-2 inches larger",
      "Prepare fresh, well-draining soil",
      "Gently remove plant from old pot",
      "Trim any dead or rotted roots",
      "Place in new pot and fill with soil",
      "Water lightly and place in indirect light"
    ]
  },
  {
    id: 2,
    title: "5 Tips for Watering Smart",
    description: "Master the art of watering to keep your plants healthy and thriving.",
    icon: "💧",
    steps: [
      "Check soil moisture with your finger",
      "Water thoroughly until it drains",
      "Use room temperature water",
      "Water in the morning when possible",
      "Adjust frequency based on season"
    ]
  },
  {
    id: 3,
    title: "Beginner's Guide to Indoor Plants",
    description: "Everything you need to know to start your indoor plant journey successfully.",
    icon: "🌱",
    steps: [
      "Start with easy, low-maintenance plants",
      "Understand your home's lighting conditions",
      "Invest in basic plant care tools",
      "Learn to read your plant's signals",
      "Create a watering schedule",
      "Don't be afraid to make mistakes"
    ]
  }
];

export const placementGuide = [
  {
    room: "Living Room",
    description: "Bright, social spaces perfect for statement plants",
    plants: ["Snake Plant", "ZZ Plant", "Fiddle Leaf Fig", "Monstera"],
    image: "https://images.stockcake.com/public/3/2/d/32d5927b-519b-4f83-a239-4112375e3322_large/sunlit-eclectic-haven-stockcake.jpg",
    tips: "Place near windows but away from direct sunlight. Consider plant size relative to furniture."
  },
  {
    room: "Bedroom",
    description: "Peaceful spaces that benefit from air-purifying plants",
    plants: ["Peace Lily", "Snake Plant", "Lavender", "Aloe Vera"],
    image: "https://images.stockcake.com/public/2/1/8/21808355-dc3e-4c0c-8b28-127f2bdd41a3_large/dreamy-mint-wonderland-stockcake.jpg",
    tips: "Choose plants that release oxygen at night. Avoid strongly scented plants if sensitive."
  },
  {
    room: "Balcony/Patio",
    description: "Outdoor spaces perfect for sun-loving plants",
    plants: ["Aloe Vera", "Spider Plant", "Herbs", "Succulents"],
    image: "https://images.stockcake.com/public/e/2/e/e2ed16be-0964-471c-8804-5fe8e9dfc0df_large/sunlit-plant-paradise-stockcake.jpg",
    tips: "Consider wind exposure and temperature fluctuations. Provide adequate drainage."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Emily Rodriguez",
    text: "Botanical Buzz helped me transform my balcony into a mini jungle! The placement tips were spot-on.",
    rating: 5,
    image: "https://source.unsplash.com/100x100/?portrait-woman"
  },
  {
    id: 2,
    name: "Marcus Chen",
    text: "As a complete beginner, the how-to guides gave me the confidence to start my plant collection. Now I have 15 thriving plants!",
    rating: 5,
    image: "https://source.unsplash.com/100x100/?portrait-man"
  },
  {
    id: 3,
    name: "Sarah Johnson",
    text: "The technical growth information helped me understand exactly what my plants needed. No more guesswork!",
    rating: 5,
    image: "https://source.unsplash.com/100x100/?portrait-professional"
  }
];
